<ng-container *ngIf="type != null && id != null">
  <angular-embed-script>
  {{ configureInit }}
  </angular-embed-script>

  <div [id]="id" [ngStyle]="{'width.px': width, 'height.px': height}">
    <angular-embed-script>
      {{ configureDivBlock }}
    </angular-embed-script>
  </div>
</ng-container>
